module.exports = __webpack_public_path__ + "static/media/parties_and_politics.9dbf8917.png";